var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "navbar-dark-mode",
      attrs: { title: _vm.dark ? "关闭夜间模式" : "开启夜间模式" },
    },
    [
      _vm.dark
        ? _c(
            "svg",
            {
              staticStyle: { width: "18px" },
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 47.96 47.96",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M24,12A12,12,0,1,0,36,24,12,12,0,0,0,24,12Zm0,20a8,8,0,1,1,8-8A8,8,0,0,1,24,32Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24,9a2,2,0,0,0,2-2V4a2,2,0,0,0-4,0V7A2,2,0,0,0,24,9Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M36,14a2,2,0,0,0,1.42-.59l2.12-2.12a2,2,0,1,0-2.83-2.83l-2.12,2.12A2,2,0,0,0,36,14Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "M44,22H41a2,2,0,0,0,0,4h3a2,2,0,1,0,0-4Z" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M37.4,34.61a2,2,0,1,0-2.83,2.82l2.12,2.13a2,2,0,0,0,2.83-2.83Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24,39a2,2,0,0,0-2,2v3a2,2,0,0,0,4,0V41A2,2,0,0,0,24,39Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M10.53,34.61,8.41,36.73a2,2,0,0,0,0,2.83,2,2,0,0,0,2.82,0l2.13-2.13a2,2,0,1,0-2.83-2.82Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M9,24a2,2,0,0,0-2-2H4a2,2,0,0,0,0,4H7A2,2,0,0,0,9,24Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M10.53,13.39a2,2,0,0,0,1.41.59,2,2,0,0,0,1.42-3.42L11.23,8.44a2,2,0,0,0-2.82,2.83Z",
                },
              }),
            ]
          )
        : _c(
            "svg",
            {
              staticStyle: { width: "18px" },
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 48 48",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M24.48,42.18A18.66,18.66,0,0,1,22.11,5,2,2,0,0,1,23.56,8.6,11.32,11.32,0,1,0,39.4,24.44,2,2,0,0,1,43,25.89,18.68,18.68,0,0,1,24.48,42.18ZM16.36,11.32A14.66,14.66,0,1,0,36.68,31.64,15.35,15.35,0,0,1,15,17.68,15.2,15.2,0,0,1,16.36,11.32Z",
                },
              }),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }